import React, { useEffect, useState } from 'react';
import { Alert, Form, Space, Select, Spin } from 'antd';
import useILTAddresses from '../../gql/hooks/useILTAddresses';
import ILTAddresesModal from './ILTAddresesModal';
import './styles.less';

const ILTAddressesDropDown = ( { hideSpinner = true, disabled } ) => {
    const { addresses, addressesLoading, addressesError } = useILTAddresses();
    const [ addressList, setAddressList ] = useState( [] );

    useEffect( () => {
        if ( addresses ) {
            setAddressList( addresses );
        }
    }, [ addresses ] );

    const addedAddressCallback = ( item ) => {
        setAddressList( [ item, ...addressList ] );
    };

    return (
        <div>
            { addressesLoading && !hideSpinner &&                                                 
                <Spin/>
            }
            
            { addressesError && 
                <Alert 
                    type="error"
                    message="An unknown error occurred. Please try again later." 
                />
            }

            { !addressesLoading && !addressesError &&
                <Space>
                    <Form.Item 
                        label="Address"
                        name="addressID"
                        rules={ [
                            { 
                                required: true,
                                message: 'Address is required' 
                            }
                        ] }
                    >
                        <Select
                            mode="single" 
                            showSearch
                            disabled={disabled}
                            allowClear
                            style={ { width: 300 } }
                            placeholder="Select Address" 
                            filterOption={ ( input, option ) => 
                                ( option?.children ? 
                                    option.children[ 0 ].type ? '' : option.children[ 0 ]
                                    : '' ).toLowerCase().includes( input.toLowerCase() )
                            }
                        >
                            {
                                addressList.map( i => {
                                    return ( 
                                        <Select.Option 
                                            key={ i.id } 
                                            value={ i.id }  
                                        >
                                            { i.label || <span className='italic'>No Name</span> }
                                        </Select.Option>
                                    );
                                } )
                            }
                        </Select>
                    </Form.Item>
                
                    {disabled ? <></> : <ILTAddresesModal addedCallback={ addedAddressCallback }/>}
                </Space>
            }
        </div>
    );
};

export default ILTAddressesDropDown;
